import { configureStore, ThunkAction, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { all } from 'redux-saga/effects';
import groupReducer, {
    switcherReducer,
    calendarInfoReducer,
    stationInfoReducer,
    callInfoReducer,
} from './Group/reducer';
import itinerariesReducer from './Itineraries/reducer';
import recommendReducer from './Recommend/reducer';
import pageReducer from '../common/Page/reducer';
import GroupSaga from '@Redux/detail/Group/saga';
import RecommendSaga from '@Redux/detail/Recommend/saga';
import ItinerariesSaga from '@Redux/detail/Itineraries/saga';
import createSagaMiddleware from 'redux-saga';

function* rootSaga() {
    yield all([...GroupSaga, ...RecommendSaga, ...ItinerariesSaga]);
}

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
    reducer: {
        groupReducer,
        itinerariesReducer,
        recommendReducer,
        pageReducer,
        switcherReducer,
        calendarInfoReducer,
        stationInfoReducer,
        callInfoReducer,
    },
    middleware: [...getDefaultMiddleware(), sagaMiddleware],
});
sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
